import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { LoadingService } from '@shared/services/loading.service';

@Component({
  selector: 'app-loading-overlay',
  standalone: true,
  imports: [MatProgressSpinnerModule],
  template: `
    @if (loadingService.isLoading()) {
      <!-- <div class="fixed z-50 flex items-center justify-center">
        <mat-spinner diameter="48"></mat-spinner>
      </div> -->

      <div class="fixed inset-0 bg-black/20 backdrop-blur-xs z-50 flex items-center justify-center">
        <div class="bg-white rounded-lg shadow-xl p-6 flex flex-col items-center gap-4">
          <mat-spinner diameter="48"></mat-spinner>
          <span class="text-gray-700 font-medium">Lädt...</span>
        </div>
      </div>
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoadingOverlayComponent {
  protected readonly loadingService = inject(LoadingService);
}
